// extracted by mini-css-extract-plugin
export default {"hideTooltip":"B--z","fadeIn":"C--z","delay":"D--z","recommendedSizeTooltip":"E--z"};